import { combineReducers } from 'redux';
import keys from 'lodash/keys';
import merge from 'lodash/merge';
import omit from 'lodash/omit';
import * as AuthActionTypes from '../auth/auth.actionTypes';
import * as ActionTypes from './user.actionTypes';

const allIds = (state = [], action) => {
  switch (action.type) {
    case ActionTypes.CREATE_USER_SUCCESS:
      return [...state, action.response.result];
    case ActionTypes.DELETE_USER_SUCCESS:
    case ActionTypes.DELETE_USER_FAILURE:
      const deletedIndex = state.indexOf(action.payload.id);
      if (deletedIndex === -1) {
        return state;
      }
      return [...state.slice(0, deletedIndex), ...state.slice(deletedIndex + 1)];
    case ActionTypes.READ_USER_SUCCESS:
      const newEntryIndex = state.indexOf(action.response.result);
      if (newEntryIndex > -1) {
        return state;
      }
      return [...state, action.response.result];
    case ActionTypes.UPDATE_USER_SUCCESS:
      return [...state, action.response.result];
    case ActionTypes.READ_USERS_SUCCESS:
      return action.response.result;
    case AuthActionTypes.LOGIN_SUCCESS:
      let userId = -1;
      if (action.response) userId = action.response.result.user.id;
      else if (action.payload && action.payload.result) userId = action.payload.result.user.id;

      const loggedInEntryIndex = state.indexOf(userId);
      if (loggedInEntryIndex > -1) {
        return state;
      }
      return [...state, userId];

    default:
      return state;
  }
};

const byId = (state = {}, action) => {
  let user = null;
  let method = null;
  // let entities = null;
  if (action.response && action.response.entities && action.response.entities.user) {
    user = action.response.entities.user;
    method = action.response.method;
    // entities = action.response.entities;
  } else if (action.payload && action.payload.entities && action.payload.entities.user) {
    user = action.payload.entities.user;
    method = action.payload.method;
    // entities = action.payload.entities;
  }
  if (user !== null) {
    if (method && method === 'DELETE') {
      // console.log('//DELETE ENTITIES FROM STATE', state, entities);
      return omit(state, keys(user));
    }
    if (method && method === 'PUT') {
      return user;
    }
    return merge({}, state, user);
  }

  return state;
};

const isFetching = (state = false, action) => {
  switch (action.type) {
    case ActionTypes.READ_USERS_REQUEST:
      return true;
    case ActionTypes.READ_USERS_FAILURE:
    case ActionTypes.READ_USERS_SUCCESS:
      return false;
    default:
      return state;
  }
};

const reducer = combineReducers({
  allIds,
  byId,
  isFetching,
  //errorMessage,
});

export default reducer;



// WEBPACK FOOTER //
// ./src/modules/user/user.reducer.js